import { SelectOptionType } from '@/components/ElementComponent/Select/types';
import { SSP_FORMAT_WRAP } from './sspFormat';
import { INVENTORY_TYPE } from '@/const/types/inventory';
import { AD_FORMAT } from '@/const/types/adformat';

export interface IFormatMapByAdFormat {[format: number]: string;}
export interface IFormatMapBySSPAdFormat {[sspFormat: number]: IFormatMapByAdFormat;}
export interface IFormatMapByInventoryType {[inventoryType: number]: IFormatMapBySSPAdFormat}
export type AD_FORMAT_MAP_TYPE = IFormatMapByInventoryType;

export const AD_FORMAT_MAP: AD_FORMAT_MAP_TYPE = {
    [INVENTORY_TYPE.banner]: {
        [SSP_FORMAT_WRAP[INVENTORY_TYPE.banner]['320x50']]: {
            [AD_FORMAT['Banner:320x50']]    : '320x50',
            [AD_FORMAT['Banner:640x100']]   : '640x100',
        },
        [SSP_FORMAT_WRAP[INVENTORY_TYPE.banner]['320x100']]: {
            [AD_FORMAT['Banner:320x100']]   : '320x100',
            [AD_FORMAT['Banner:640x200']]   : '640x200',
        },
        [SSP_FORMAT_WRAP[INVENTORY_TYPE.banner]['300x250']]: {
            [AD_FORMAT['Banner:300x250']]   : '300x250',
            [AD_FORMAT['Banner:600x500']]   : '600x500',
        },
        [SSP_FORMAT_WRAP[INVENTORY_TYPE.banner]['excluded']]: {
            // [AD_FORMAT['Banner:300x45']]    : '300x45',
        }
    },
    [INVENTORY_TYPE.interstitial]: {
        [SSP_FORMAT_WRAP[INVENTORY_TYPE.interstitial]['320x480']]: {
            [AD_FORMAT['Interstitial:320x480']]   :'320x480',
            [AD_FORMAT['Interstitial:640x960']]   :'640x960',
        },
        [SSP_FORMAT_WRAP[INVENTORY_TYPE.interstitial]['480x320']]: {
            [AD_FORMAT['Interstitial:480x320']]   :'480x320',
            [AD_FORMAT['Interstitial:960x640']]   :'960x640',
        },
        [SSP_FORMAT_WRAP[INVENTORY_TYPE.interstitial]['0x0']]: {
            [AD_FORMAT['Interstitial:320x480']]   :'320x480',
            [AD_FORMAT['Interstitial:640x960']]   :'640x960',
            [AD_FORMAT['Interstitial:480x320']]   :'480x320',
            [AD_FORMAT['Interstitial:960x640']]   :'960x640',
        },
        [SSP_FORMAT_WRAP[INVENTORY_TYPE.interstitial]['excluded']]: {
            // [AD_FORMAT['Interstitial:500x800']]   :'500x800',
            // [AD_FORMAT['Interstitial:900x1458']]  :'900x1458',
            // [AD_FORMAT['Interstitial:750x1200']]  :'750x1200',
            // [AD_FORMAT['Interstitial:800x1280']]  :'800x1280',
            // [AD_FORMAT['Interstitial:640x600']]   :'640x600',
            // [AD_FORMAT['Interstitial:610x855']]   :'610x855',
            // [AD_FORMAT['Interstitial:800x1230']]  :'800x1230',
            // [AD_FORMAT['Interstitial:768x974']]   :'768x974',
            // [AD_FORMAT['Interstitial:720x1230']]  :'720x1230',
        }
    },
    [INVENTORY_TYPE.native]: {
        [SSP_FORMAT_WRAP[INVENTORY_TYPE.native]['0x0']]: {
            [AD_FORMAT['Native:80x80']]       : '80x80',
            [AD_FORMAT['Native:128x128']]     : '128x128',
            [AD_FORMAT['Native:1200x627']]    : '1200x627',
            [AD_FORMAT['Native:1200x628']]    : '1200x628',
            [AD_FORMAT['Native:300x300']]     : '300x300',
            [AD_FORMAT['Native:400x400']]     : '400x400',
            [AD_FORMAT['Native:328x152']]     : '328x152',
            [AD_FORMAT['Native:280x280']]     : '280x280',
            [AD_FORMAT['Native:560x560']]     : '560x560',
            [AD_FORMAT['Native:624x328']]     : '624x328',
            [AD_FORMAT['Native:656x304']]     : '656x304',
            [AD_FORMAT['Native:615x366']]     : '615x366',
            [AD_FORMAT['Native:328x140']]     : '328x140',
            [AD_FORMAT['Native:656x280']]     : '656x280',
            [AD_FORMAT['Native:680x170']]     : '680x170',
            [AD_FORMAT['Native:335x415']]     : '335x415',
            [AD_FORMAT['Native:320x120']]     : '320x120',
            [AD_FORMAT['Native:640x240']]     : '640x240',
            [AD_FORMAT['Native:720x436']]     : '720x436',
            [AD_FORMAT['Native:310x218']]     : '310x218',
            [AD_FORMAT['Native:640x336']]     : '640x336',
            [AD_FORMAT['Native:320x192']]     : '320x192',
            [AD_FORMAT['Native:640x384']]     : '640x384',
            [AD_FORMAT['Native:320x168']]     : '320x168',
            [AD_FORMAT['Native:320x268']]     : '320x268',
            [AD_FORMAT['Native:640x536']]     : '640x536',
            [AD_FORMAT['Native:750x604']]     : '750x604',
            [AD_FORMAT['Native:750x260']]     : '750x260',
            [AD_FORMAT['Native:750x412']]     : '750x412',
            [AD_FORMAT['Native:1029x258']]    : '1029x258',
            [AD_FORMAT['Native:335x260']]     : '335x260',
            [AD_FORMAT['Native:335x174']]     : '335x174',
            [AD_FORMAT['Native:670x348']]     : '670x348',
            [AD_FORMAT['Native:1200x1200']]   : '1200x1200',
            [AD_FORMAT['Native:700x394']]     : '700x394',
            [AD_FORMAT['Native:840x560']]     : '840x560',
            [AD_FORMAT['Native:700x524']]     : '700x524',
            [AD_FORMAT['Native:360x80']]      : '360x80',
            [AD_FORMAT['Native:720x160']]     : '720x160',
            [AD_FORMAT['Native:286x172']]     : '286x172',
            [AD_FORMAT['Native:572x344']]     : '572x344',
            [AD_FORMAT['Native:320x370']]     : '320x370',
            [AD_FORMAT['Native:620x512']]     : '620x512',
            [AD_FORMAT['Native:640x160']]     : '640x160',
            [AD_FORMAT['Native:640x178']]     : '640x178',
        },
        [SSP_FORMAT_WRAP[INVENTORY_TYPE.native]['1200x627 & 1200x628']]: {
            [AD_FORMAT['Native:80x80']]       : '80x80',
            [AD_FORMAT['Native:128x128']]     : '128x128',
            [AD_FORMAT['Native:1200x627']]    : '1200x627',
            [AD_FORMAT['Native:1200x628']]    : '1200x628',
        },
        [SSP_FORMAT_WRAP[INVENTORY_TYPE.native]['300x300']]: {
            [AD_FORMAT['Native:80x80']]       : '80x80',
            [AD_FORMAT['Native:128x128']]     : '128x128',
            [AD_FORMAT['Native:300x300']]     : '300x300',
        },
        [SSP_FORMAT_WRAP[INVENTORY_TYPE.native]['400x400']]: {
            [AD_FORMAT['Native:80x80']]       : '80x80',
            [AD_FORMAT['Native:128x128']]     : '128x128',
            [AD_FORMAT['Native:400x400']]     : '400x400',
        },
    }
};// banner 320 x 480~~~


export interface ISSPFormatSelectMap {[sspFormat: number]: SelectOptionType[];}
export interface ITypeSelectMaps {[inventoryType: number]: ISSPFormatSelectMap;}

export const AD_FORMAT_SELECT = (() => {
    const formatWrap = (target: IFormatMapByAdFormat) => Object.entries(target).reduce<SelectOptionType[]>(
            (formatMap: SelectOptionType[], curr: [string, string],) => {
                const key = Number.parseInt(curr[0]);
                const format = curr[1];
                return [ 
                    ...formatMap,
                    {
                        label: format,
                        value: key,
                    }
                ];
        }, [])

    const sspFormatWrap = (target: IFormatMapBySSPAdFormat) => Object.entries(target).reduce<ISSPFormatSelectMap>(
            (sspFormatMap: ISSPFormatSelectMap, curr: [string, IFormatMapByAdFormat]) => {
                const sspFormat = Number.parseInt(curr[0]);
                const formats = curr[1];
                return { ...sspFormatMap, [sspFormat]: formatWrap(formats) };
        }, {})

    const inventoryWrap = () => Object.entries(AD_FORMAT_MAP).reduce<ITypeSelectMaps>(
        (invMap: ITypeSelectMaps, curr: [string, IFormatMapBySSPAdFormat]) => {
            const invType = Number.parseInt(curr[0]);
            const sspFormats = curr[1];
            return { ...invMap, [invType]: sspFormatWrap(sspFormats) };
        }, {})

    return inventoryWrap();
})();
